// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1g9oK","resendInfoText":"OnGoingPaymentBox_resendInfoText__3xzq3"};